<!--
component: ZoomCanvas
author: Ken Nakamura
description: 部分拡大画像表示コンポーネント（HTML5 Canvas版）
-->
<template>
  <section class="zoom-image-viewer scroll-hidden">
    <!--<div width="100%" height="100%">-->
      <canvas id="zoom-canvas"
        style="position: absolute; margin:0; padding:0"
      ></canvas>
    <!--</div>-->
  </section>
</template>
<script>
export default {
  data() {
    return {
      scale: 0,
    }
  },
  props: {
    sourceImage: {
      type: HTMLImageElement ,
      require: true,
    },
    zoom: {
      type: Number,
      default: 1,
    },
    centerx: {
      type: Number,
      default: 0,
    },
    centery: {
      type: Number,
      default: 0,
    }
  },
  mounted () {
  },
  watch:{
    sourceImage: {
      handler(value) {
        this.drawImage(value, this.centerx, this.centery, this.zoom);
      }
    },
    zoom: {
      immediate: true,
      handler(value) {
        this.drawImage(this.sourceImage, this.centerx, this.centery, value);
      }
    },
    centerx: {
      immediate: true,
      handler(value) {
        this.drawImage(this.sourceImage, value, this.centery, this.zoom);
      }
    },
    centery: {
      immediate: true,
      handler(value) {
        this.drawImage(this.sourceImage, this.centerx, value, this.zoom);
      }
    },
  },
  computed: {
  },
  methods: {
    drawImage(image, cx, cy, zoom) {
      if (image) {
        const canvas = document.getElementById('zoom-canvas');
        const context = canvas.getContext('2d');
        const parent = canvas.parentElement;
        //const parentRatio = parent.clientHeight / parent.clientWidth;
        const parentRatio = 2 / 3;
        const w = image.width / zoom;
        //const h = image.height / image.width * w;
        const h = w * parentRatio;
        const x = cx - w / 2;
        const y = cy - h / 2;
        const ratio = w / parent.clientWidth;
        if (ratio > 4) {
          canvas.width = w / 4;
          canvas.height = h / 4;
          const tempCanvas = document.createElement('canvas');
          const tempContext = tempCanvas.getContext('2d');      
          tempCanvas.width = w / 2;
          tempCanvas.height = h / 2;
          tempContext.drawImage(image, x, y, w, h, 0, 0, tempCanvas.width, tempCanvas.height);       
          context.drawImage(tempCanvas, 0, 0, tempCanvas.width, tempCanvas.height,
            0, 0, canvas.width, canvas.height);
        }
        else if (ratio > 2) {
          canvas.width = w / 2;
          canvas.height = h / 2;
          context.drawImage(image, x, y, w, h, 0, 0, canvas.width, canvas.height);
        }
        else {
          canvas.width = w;
          canvas.height = h;
          context.drawImage(image, x, y, w, h, 0, 0, canvas.width, canvas.height);
        }
        canvas.style.width = `${parent.clientWidth}px`;
        canvas.style.height = `${parent.clientWidth * 2 / 3}px`;
      }
    }
  },  
}
</script>
<style lang="scss" scoped>
.scroll-hidden {
	overflow: hidden;
}
